import {
  Directive,
  ElementRef,
  HostListener,
  Renderer2,
  Input,
  Optional,
  Self,
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[txpIntegersOnly]',
  standalone: true,
})
export class TxpIntegersOnlyDirective {
  @Input() allowZeros = false;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    @Optional() @Self() private ngControl: NgControl, // Access FormControl
  ) {}

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    let inputValue = input.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters

    if (this.allowZeros) {
      // Ensure all zeros become a single "0"
      if (/^0+$/.test(inputValue)) {
        inputValue = '0';
      }
    } else {
      // Remove leading zeros when allowZeros is false
      inputValue = inputValue.replace(/^0+/, '');
    }

    // Update the input field
    this.renderer.setProperty(input, 'value', inputValue);

    // If using Angular forms, update the FormControl value
    if (this.ngControl?.control) {
      this.ngControl.control.setValue(inputValue, { emitEvent: false });
    }
  }
}
